import { type UseQueryResult, useQuery } from '@tanstack/react-query';
import { api } from '../lib/apiClient';
import type { LotDetailResponse } from '../lib/lots';

const DETAIL_REFETCH_MS = 5_000;
const DETAIL_STALE_MS = 3_000;

export function useLotDetail(lotId: string): UseQueryResult<LotDetailResponse> {
  return useQuery({
    queryKey: ['lot', lotId],
    queryFn: ({ signal }) => api.get<LotDetailResponse>(`/api/lots/${lotId}`, { signal }),
    staleTime: DETAIL_STALE_MS,
    refetchInterval: (query) => {
      const data = query.state.data;
      if (data && data.lot.status === 'closed') return false;
      return DETAIL_REFETCH_MS;
    },
  });
}
